export function deepCopy<T>(obj: T): T {

  if (obj === null || typeof obj !== 'object')
   {
    return obj;
   }

  if (Array.isArray(obj))
   {
    return obj.map(item => deepCopy(item)) as unknown as T;
   }

  const copy = {} as T;

  for (const key in obj)
   {
    if (obj.hasOwnProperty(key))
     {
      (copy as any)[key] = deepCopy((obj as any)[key]);
     }
   }

  return copy;
}

export const arraysAreEqual = (arr1: number[], arr2: number[]) => {
  return arr1.length === arr2.length && arr1.sort().every((value, index) => value === arr2.sort()[index]);
};
